/**
 * Olvida el comercio TPV que el operador dejó aplicado en esta pestaña.
 *
 * Lo usa `/products` (feature 152, R19/R20): elegir una empresa o unidad TPV, u
 * "Omitir", entra al dashboard de TPV SIN comercio. Antes esa limpieza la hacía el
 * dashboard al montarse, pero desde 2026-10-19 el dashboard CONSERVA el comercio
 * elegido en otra pantalla de TPV (pedido del humano), así que la limpieza vive en
 * el único gesto que debe provocarla.
 *
 * Puerto chico a propósito (ISP): la pantalla de productos no puede importar nada
 * de `tpv/` (feature autocontenida) y solo necesita esta operación. Lo implementa
 * `SelectedMerchantService` y se enlaza en `app.config.ts`.
 */
export abstract class TpvSelectedMerchantReset {
  abstract clear(): void;
}
